import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router";
import { storeTokens } from "@/lib/token-store";

export function TokenAuthPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = params.get("token");
    const refresh = params.get("refresh");
    const redirect = params.get("redirect") || "/";

    if (token && refresh) {
      storeTokens(token, refresh);
    }

    navigate(redirect, { replace: true });
  }, [params, navigate]);

  return null;
}
